import axios from 'axios'

/**
 * Errors caught in a `catch` block are `unknown` becuse it could be anything.
 * This utility safely extracts a error message as a string.
 */
export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) return error.message // Handles standard JS Errors
  if (error && typeof error === 'object' && 'message' in error) {
    return String(error.message) // Handles generic objects containing a message property
  }
  return String(error) // Fallback for raw strings or numbers thrown
}

/**
 * Checks for either Axios cancellation or native AbortController signal throw
 */
export function isAbortError(error: unknown): boolean {
  return (
    axios.isCancel(error) ||
    (error instanceof DOMException && error.name === 'AbortError')
  )
}
